import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MenuSideCourseItemDoneComponent } from '../menu-side-course-item-done/menu-side-course-item-done.component';
import { User } from '@klickdata/core/user';
import { TakeResActionValue } from '@klickdata/player/src/next-step.service';
import { filter, Subject, switchMap, takeUntil } from 'rxjs';
import { AuthService } from '@klickdata/core/auth';
import { ResourceOpportunity } from '@klickdata/core/opportunity';
import { OccasionService } from '@klickdata/player/src/core/occasion/occasion.service';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-menu-side-course-item-done-all',
    templateUrl: './menu-side-course-item-done-all.component.html',
    styleUrls: ['./menu-side-course-item-done-all.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideCourseItemDoneAllComponent extends MenuSideCourseItemDoneComponent implements OnInit, OnDestroy {
    public userIsDone: boolean;
    public showGroupWork: boolean;
    public participantUsers: User[];
    public authUser: User;
    public showGroups: boolean;
    public destroy: Subject<boolean> = new Subject<boolean>();
    public auth: AuthService;
    public canDonWithGroup: boolean;
    public hideMain = false;
    public hideSignoff = false;
    public hideGroupWork = false;
    public hideDoneGroupWork = false;
    public timeSpendControl: FormControl = new FormControl();
    constructor(cdr: ChangeDetectorRef, auth: AuthService, protected occasionService: OccasionService) {
        super(cdr);
        this.auth = auth;
    }
    ngOnInit(): void {
        this.auth
            .getUser()
            .pipe(takeUntil(this.destroy))
            .subscribe((user) => {
                this.authUser = user;
                this.canDonWithGroup = user.canPlayAsGroupLeader();
            });
    }
    onSignoff() {
        if (this.canDonWithGroup) {
            this.showGroupWork = true;
        } else {
            this.onDone();
        }
        this.cdr.markForCheck();
    }

    onDone() {
        this.showGroups = false;
        this.onClose.emit({
            data: {
                type: this.navData.data.type,
                response: TakeResActionValue.SIGNOFF,
                signoff: this.navData.data.course.user_collaboration?.signoff_required?.status
                    ? { body: this.feedback.value }
                    : null,
            },
        });
    }
    submitWithGroup() {
        this.navData.data.childOccasion$
            .pipe(
                takeUntil(this.destroy),
                filter((res) => !!res),
                switchMap((res: ResourceOpportunity) =>
                    this.occasionService.doneGroupWork(
                        res.parent_id,
                        this.participantUsers.map((user) => user.id).filter((id) => id != this.authUser.id),
                        true,
                        this.showGroups && this.timeSpendControl.value ? this.timeSpendControl.value : undefined
                    )
                )
            )
            .subscribe(() => this.onDone());
    }
    ngOnDestroy(): void {
        this.destroy.next(true);
        this.destroy.unsubscribe();
    }
}
